import { VehicleSearchOutput } from '@allocab/allocab-driver-service-types';
import { useMutation } from '@tanstack/react-query';

import { silentQueryErrorHandler } from '../services/datastore/react-query';
import { driverApi } from '../services/network/Api';

const fetchVehicleInfo = (licencePlate: string) =>
  driverApi.get<void, VehicleSearchOutput>(`/v1/vehicle/info/${licencePlate}`);

export const useFetchVehicleInfo = () =>
  useMutation<VehicleSearchOutput, unknown, string>({
    mutationFn: fetchVehicleInfo,
    onError: silentQueryErrorHandler,
  });
